import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import dental_already_covered from './dental_already_covered'
import dental_birthday from './dental_birthday'
import dental_consent from './dental_consent'
import dental_coverage from './dental_coverage'
import dental_coverage_dates from './dental_coverage_dates'
import dental_generic_failure from './dental_generic_failure'
import dental_health_insurance_type from './dental_health_insurance_type'
import dental_instant from './dental_instant'
import dental_missing_teeth from './dental_missing_teeth'
import dental_periodontal_disease from './dental_periodontal_disease'
import dental_previous_coverage from './dental_previous_coverage'
import dental_previous_coverage_breakdown from './dental_previous_coverage_breakdown'
import dental_previous_coverage_with_gap from './dental_previous_coverage_with_gap'
import dental_previous_insurance from './dental_previous_insurance'
import dental_previous_insurer from './dental_previous_insurer'
import dental_previous_reimbursement from './dental_previous_reimbursement'
import dental_purchase from './dental_purchase'
import dental_quote from './dental_quote'
import dental_underwriting from './dental_underwriting'

const getSteps = (params: StepConfigParams, plaform: 'native' | 'web') =>
  ({
    // Pre-quote questions - combined for web
    dental_instant: dental_instant(params),

    // Pre-quote questions - separate steps for app
    dental_birthday: dental_birthday(params),
    dental_health_insurance_type: dental_health_insurance_type(params),
    dental_missing_teeth: dental_missing_teeth(params),
    dental_periodontal_disease: dental_periodontal_disease(params),

    // Coverage questions - combined for the web revamp
    dental_coverage: dental_coverage(params),

    // Quote display
    dental_quote: dental_quote(params, plaform),

    // Personal details
    dental_personal_details: personal_details(params, {
      nextStep: 'dental_previous_insurance',
      lockBirthdate: true,
      translations: {
        title: 'sharedFlows_dental:steps.dental_personal_details.title',
        birthdateLabel: 'sharedFlows_dental:steps.dental_personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_dental:steps.dental_personal_details.marketingOptIn',
        minAgeError: 'sharedFlows_dental:steps.dental_instant.errorTooYoung',
        maxAgeError: 'sharedFlows_dental:steps.dental_instant.errorTooOld',
      },
      trackContactBlur: true,
    }),

    // Personal details - first step of the web revamp
    dental_personal_details_new: personal_details(params, {
      nextStep: 'dental_coverage',
      maxAge: 65,
      layout: 'new',
      translations: {
        title: 'sharedFlows_dental:steps.dental_personal_details.title',
        birthdateLabel: 'sharedFlows_dental:steps.dental_personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_dental:steps.dental_personal_details.marketingOptIn',
        minAgeError: 'sharedFlows_dental:steps.dental_instant.errorTooYoung',
        maxAgeError: 'sharedFlows_dental:steps.dental_instant.errorTooOld',
      },
      trackContactBlur: true,
    }),

    // Previous insurance flow (split into separate steps)
    dental_previous_insurance: dental_previous_insurance(params, plaform),
    dental_previous_insurer: dental_previous_insurer(params),
    dental_coverage_dates: dental_coverage_dates(params),
    dental_previous_coverage: dental_previous_coverage(params),
    dental_previous_coverage_breakdown: dental_previous_coverage_breakdown(params, plaform),
    dental_previous_coverage_with_gap: dental_previous_coverage_with_gap(params, plaform),
    dental_previous_reimbursement: dental_previous_reimbursement(params, plaform),

    // underwriting and consent
    dental_underwriting: dental_underwriting(params, plaform),
    dental_consent: dental_consent(params),

    dental_purchase: dental_purchase(params),

    // Error states
    dental_already_covered: dental_already_covered(params),
    dental_missing_teeth_failure: dental_generic_failure(params, {
      translations: {
        title: 'sharedFlows_dental:steps.dental_missing_teeth_failure.title',
        description: 'sharedFlows_dental:steps.dental_missing_teeth_failure.description',
      },
    }),
  }) as const satisfies AnySteps

export default getSteps
